import { Center, Column, CustomSpinner, Pagination } from '~/commonComponents';
import { CandidateStatusFilterPanel } from '../../../components';
import { CandidateListTable } from './CandidateListTable';
import { useCandidateTabView } from './useCandidateTabView';

interface ICandidateTabViewProps {
  jobPostingId: string;
}

export const CandidateTabView = ({ jobPostingId }: ICandidateTabViewProps) => {
  const { data, filters, isInitialLoading, isLoading, methods, pagination, statistics } =
    useCandidateTabView(jobPostingId);

  return (
    <Column paddingInline={80}>
      <CandidateStatusFilterPanel counts={statistics.tabs} onChange={methods.setStatusFilter} />
      {isInitialLoading ? (
        <Center marginBlock={32}>
          <CustomSpinner isLoading size={32} />
        </Center>
      ) : (
        <>
          <CandidateListTable
            data={data}
            isLoading={isLoading}
            jobPostingId={jobPostingId}
            sorting={filters.sorting}
            onSortingChange={methods.setSorting}
          />
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={methods.setCurrentPage}
          />
        </>
      )}
    </Column>
  );
};
